export const List = () => {
  return (
    <svg viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="1" cy="1" r="1" fill="currentColor" />
      <circle cx="1" cy="6" r="1" fill="currentColor" />
      <circle cx="1" cy="11" r="1" fill="currentColor" />
      <path
        d="M4.44531 11H16.0009"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.44531 6H16.0009"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.44531 1H16.0009"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
